<template>
  <div>
      <b-row> 
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Centro de Custo</label>
                    <b-form-select
                        :options="cCustos"
                        v-model="cCusto"
                        text-field="nomeCodCCusto"
                        value-field="codCCusto"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label class="required">Natureza Orçamentária</label>
                    <b-form-select
                        :options="orcamentosFormatados"
                        v-model="orcamento"
                        text-field="codigoDescricao"
                        value-field="codigo"
                        :state="$v.orcamento.$error ? false : null"
                        @input="$v.orcamento.$touch()"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Selecione...
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Natureza Orçamentária é obrigatória</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <!-- <b-col sm="12" md="3">
                <b-form-group>
                    <label>Departamentos</label>
                    <b-form-select
                        :options="departamentos"
                        v-model="departamento"
                        text-field="nome"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col> -->
        </b-row>
        <!-- <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Despesa / Receita</label>
                    <b-form-select
                        :options="despesasReceita"
                        v-model="despesaReceita"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col>
        </b-row> -->
        <!-- <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Vendedor 1</label>
                    <b-form-select
                        :options="vendedores"
                        v-model="vendedor1"
                        text-field="nome"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Vendedor 2</label>
                    <b-form-select
                        :options="vendedores"
                        v-model="vendedor2"
                        text-field="nome"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> 
            </b-col>
        </b-row> -->
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'


export default {
    components: {
        ModelListSelect
    },

    props: {
        cCustos: {
            type: Array,
            default: () => {}    
        },
        departamentos: {
            type: Array,
            default: () => {}        
        },
        despesasReceita: {
            type: Array,
            default: () => {}
        },
        orcamentos: {
            type: Array,
            default: () => []
        },
        vendedores: {
            type: Array,
            default: () => {}
        },
        item: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: String,
            default: () => ""
        }
    },
    
    data() {
        return {
            cCusto: '',
            departamento: '',
            despesaReceita: '',
            orcamento: null,
            vendedor1: '',
            vendedor2: '',
            textoAcao: this.acao,
            invalid: ''
        }
    },

    methods: {
        verificarAcao() {
            if (this.acao == 'Inserir'){
                this.preencherFormInserir()
            } else {
                this.preencherFormAtualizar()
            }
        },

        preencherFormInserir() {
            
        },

        preencherFormAtualizar() {
            this.cCusto = this.item.codCCusto
            this.departamento = this.item.codDepartamento
            this.despesaReceita = this.item.codDespesaReceita
            this.orcamento = this.item.codOrcamento
            // this.vendedor1 = this.item.codVendedor1
            // this.vendedor2 = this.item.codVendedor2
        },
    },

    computed: {
        tabelas() {
            return {
                cCusto: this.cCusto,
                // departamento: this.departamento,
                despesaReceita: this.despesaReceita,
                orcamento: this.orcamento,
                // vendedor1: this.vendedor1,
                // vendedor2: this.vendedor2,
                invalid: this.$v.$invalid
            }
        },
        orcamentosFormatados() {
            return this.orcamentos
                .map(o => ({
                    ...o,
                    codigoDescricao: `${o.codigo} - ${o.descricao}`
                }))
                .sort((a, b) => a.descricao.localeCompare(b.descricao))
        }
    },

    created() {
        this.verificarAcao()
    },

    watch: {
        tabelas() {
            this.$emit('atualizarTabelas', this.tabelas)
        }
    },

    validations: {
        orcamento: {
            required
        }
        // despesaReceita: {
        //     required
        // }
    }
}

</script>

<style>

</style>